export default "__VITE_ASSET__B91iNB8g__"